'use strict';
var parent = require('../../actual/weak-set');
require('../../modules/es.string.iterator');
require('../../modules/esnext.weak-set.add-all');
require('../../modules/esnext.weak-set.delete-all');
require('../../modules/esnext.weak-set.from');
require('../../modules/esnext.weak-set.of');

module.exports = parent;
